import { z } from 'zod';
import { optionalNullableDateInput, requiredUuidString } from '../zod-helpers/index.js';
import { MANUFACTURING_ORDER_CONSTRAINTS, MAX_MANUFACTURING_ORDER_LINES, MAX_MANUFACTURING_ORDER_LINES_MESSAGE, } from './constraints.js';
import { manufacturingOrderLineInputSchema } from './line-input.js';
export const createManufacturingOrderInputSchema = z.object({
    brandId: requiredUuidString(`${MANUFACTURING_ORDER_CONSTRAINTS.brand.label} is required.`, 'Invalid brand selection.'),
    locationGroupId: requiredUuidString(`${MANUFACTURING_ORDER_CONSTRAINTS.locationGroup.label} is required.`, 'Invalid warehouse selection.'),
    // Optional, as the column is: a job raised before anyone knows when it is due is a real
    // thing on the floor, and demanding a date here would only get an invented one.
    dateScheduled: optionalNullableDateInput,
    note: z
        .string()
        .max(MANUFACTURING_ORDER_CONSTRAINTS.note.maxLength, `${MANUFACTURING_ORDER_CONSTRAINTS.note.label} must be ${MANUFACTURING_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    lines: z
        .array(manufacturingOrderLineInputSchema)
        .min(1, 'At least one part line is required.')
        .max(MAX_MANUFACTURING_ORDER_LINES, MAX_MANUFACTURING_ORDER_LINES_MESSAGE),
});
//# sourceMappingURL=create-input.js.map